import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/types';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'horizontal';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
      >
        <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-md overflow-hidden">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
              {article.category}
            </span>
            <span className="text-xs text-foreground-400">{article.publishDate}</span>
          </div>
          <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2">{article.excerpt}</p>
          <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
            <span>{article.author}</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
    >
      <div className="w-full h-48 overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
            {article.category}
          </span>
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
        </div>
        <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 flex-1">{article.excerpt}</p>
        <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
          <span>{article.author}</span>
          <span>{article.readTime}</span>
        </div>
      </div>
    </Link>
  );
}